import { createContext, useCallback, useState } from 'react'
import { ResizeObserver } from '@juggle/resize-observer'
import styles from './embeddedWidget.module.css'
import { useHost } from 'data/hosts'
import { isNil } from 'lodash'
import { getSendHeightFunction } from 'utilities/frame'
import { useIsAdminUserForBlog } from 'data/blogs/client'

type Props = {
  children: React.ReactNode,
  hostId: string,
  isAdmin?: boolean,
}

type Context = {
  isAdmin?: boolean,
  hostId?: string,
}

export const BlotterContext = createContext<Context>({})

const EmbeddedWidget = ({ hostId, children, isAdmin = false }: Props) => {
  const { host } = useHost(hostId)
  const { isAdminUser } = useIsAdminUserForBlog(hostId)
  const [height, setHeight] = useState(0)
  const sendHeight = getSendHeightFunction(host, isAdmin)
  // console.log('EMBEDDED WIDGET', hostId, host)
  const measuredRef = useCallback(node => {
    const resizeObserver = new ResizeObserver((entries) => { // observer
      if (entries?.[0]?.contentRect?.height) {
        const elHeight = entries[0].contentRect.height
        // console.log({ elHeight })
        if (elHeight !== height) {
          setHeight(elHeight)
          sendHeight(elHeight)
        }
        // after 10 seconds, disconnect observer to free up resources (is this helpful?!?)
        // setTimeout(() => {
        //   observer.disconnect()
        // }, 10000)
      }
    })
    node && resizeObserver.observe(node)
  }, [height, sendHeight])
  if (isNil(host)) return null
  return <BlotterContext.Provider value={{ isAdmin: isAdminUser, hostId }}>
    <div ref={measuredRef} className={styles.embeddedWidget}>
      { children }
    </div>
  </BlotterContext.Provider>
}

export default EmbeddedWidget
